import { gql, useMutation } from '@apollo/client';
import { Graph } from 'src/generated/graph';

const UPDATE_SUPPLIER_PRODUCT_ENABLE_WEBSITE = gql`
  mutation UpdateSupplierProductEnableWebsite($id: Int!, $enable: Boolean!) {
    updateSupplierProductEnableWebsite(id: $id, enable: $enable)
  }
`;

export default function useMutationUpdateSupplierProductEnableWebsite() {
  return useMutation<
    Graph.Mutation,
    {
      id: number;
      enable: boolean;
    }
  >(UPDATE_SUPPLIER_PRODUCT_ENABLE_WEBSITE);
}
